module.exports = __webpack_public_path__ + "img/preview.c40ad0dd.svg";